import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { MdLanguage } from "react-icons/md"; // ícono de globo alternativo
import Flag from "react-world-flags";

export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    handleClose();
  };

  return (
    <div>
      <IconButton onClick={handleClick} sx={{ color: "#1B2466", marginTop: ".4rem" }}>
        <MdLanguage size={24} />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        container={document.body}      // 👈 renderiza fuera del AppBar
        disablePortal={false}          // 👈 asegura que se use el portal
        disableScrollLock={true}       // 👈 permite scrollear aunque esté abierto
        sx={{ zIndex: 2000 }}          // 👈 por encima del navbar
      >
        <MenuItem onClick={() => changeLanguage("es")}>
          <ListItemIcon>
            <Flag code="AR" style={{ width: 32, height: 24 }} />
          </ListItemIcon>
          <ListItemText>{t("idioma_espaniol")}</ListItemText>
        </MenuItem>

        <MenuItem onClick={() => changeLanguage("en")}>
          <ListItemIcon>
            <Flag code="US" style={{ width: 32, height: 24 }} />
          </ListItemIcon>
          <ListItemText>{t("idioma_ingles")}</ListItemText>
        </MenuItem>
      </Menu>
    </div>
  );
}
